module.exports = __webpack_public_path__ + "dd595e1553b89bccb95033048be7e739.png";


//////////////////
// WEBPACK FOOTER
// ./shared/favicons/favicon-32x32.png
// module id = 1152
// module chunks = 2